import { useMemo } from 'react';
import { RouletteLabelProps } from './props';

import useLuckySpinState from '@/hooks/lucky-spin/useLuckySpinState';
import { Image } from '@starsoft/common/components';
import { WalletService } from '@starsoft/common/services';
import { getMoneyOrAmount } from '@starsoft/common/utils';
import styles from './styles.module.scss';

export default function LuckySpinLabels({ isSpinning }: RouletteLabelProps) {
  const {
    useLuckySpinsRewardsByLuckySpinQuery: { spinsRewards, prizeIndex },
  } = useLuckySpinState();

  const Labels = useMemo(
    () =>
      spinsRewards?.data?.map((reward, index) => (
        <div
          style={{
            //@ts-ignore
            '--position': index,
          }}
          key={`label-lucky-spin-${index}`}
          className={`${styles.wrapper__label} ${process.env.NEXT_PUBLIC_TENANT_ID === 'kube' ? styles['wrapper__label--kube'] : ''}`}
        >
          {WalletService.maskCurrency({
            amount: getMoneyOrAmount(reward?.amount),
            coin: reward?.coin,
            hideSymbol: true,
          })}
          <Image
            alt={`prize-image-${reward?.coin?.name}`}
            format="square"
            width={22}
            className={styles.wrapper__coin}
            height={22}
            src={`${process.env.NEXT_PUBLIC_S3_BUCKET_BASE_URL}/coins/rounded/${
              reward?.coin?.image ?? 'brl.svg'
            }`}
            secondarySkeleton
          />
        </div>
      )),
    [spinsRewards],
  );

  return (
    <div
      isSpinning={isSpinning}
      prizeIndex={Number(prizeIndex)}
      style={{
        //@ts-ignore
        '--prize-index': Number(prizeIndex) ?? 10,
      }}
      className={`${styles.wrapper} ${isSpinning ? styles['wrapper--spinning'] : ''}`}
    >
      {Labels}
    </div>
  );
}
